var _ellipse, _path, _circle, _circle2, _path2, _path3, _path4, _ellipse2, _path5, _circle3, _circle4, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 28,
    viewBox: "0 0 111 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6084,
    cy: 24.348,
    rx: 7.91304,
    ry: 3.65217,
    fill: "#E97A7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26038 14.0219C5.26038 21.766 12.6085 17.6522 25.3692 17.6522C33.1133 17.6522 33.3042 21.766 33.3042 14.0219C33.3042 6.27782 27.0264 0 19.2823 0C11.5382 0 5.26038 6.27782 5.26038 14.0219Z",
    fill: "#201714"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.17383,
    cy: 4.17383,
    r: 4.17383,
    transform: "matrix(-1 0 0 1 19.2598 4.65234)",
    fill: "#F7F7F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 27.4902 11)",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71739 20.4605C5.14964 20.6543 4.68799 20.8118 4.35026 20.8999C3.6997 21.0697 3.03469 20.6799 2.86494 20.0294C2.69518 19.3788 3.08495 18.7138 3.73551 18.5441C3.93239 18.4927 4.25687 18.3805 4.68955 18.2309C6.67532 17.5443 10.9401 16.0698 15.6081 16.0698C18.4486 16.0698 22.8356 16.6041 26.5135 17.1692C28.3642 17.4535 30.0607 17.7497 31.3271 17.9983C31.9585 18.1222 32.4938 18.2365 32.8918 18.3333C33.0888 18.3812 33.2681 18.4287 33.4149 18.4746C33.4872 18.4971 33.5689 18.5246 33.6485 18.5572L33.6519 18.5586C33.7011 18.5787 33.8724 18.6486 34.0357 18.7835C34.554 19.2118 34.627 19.9792 34.1987 20.4975C33.8253 20.9493 33.1942 21.0627 32.6951 20.8005C32.6931 20.7999 32.6911 20.7993 32.689 20.7986C32.6141 20.7752 32.492 20.7418 32.3163 20.6991C31.9688 20.6146 31.4735 20.5083 30.858 20.3875C29.6307 20.1465 27.9679 19.856 26.1437 19.5757C22.4717 19.0115 18.2459 18.5046 15.6081 18.5046C11.4487 18.5046 7.84093 19.7358 5.71739 20.4605Z",
    fill: "#201714"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58384 9C2.38384 11.8 5.7505 13.5 7.58384 14C9.25046 14.8333 11.3837 16.4 6.58372 16C1.78372 15.6 2.5838 11.1667 3.58384 9Z",
    fill: "#201714"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41172 13.7693C2.25988 16.6952 5.94097 15.8742 7.67549 15.0979C9.49255 14.6851 12.1355 14.5433 8.17079 17.2785C4.20609 20.0137 2.01278 16.0787 1.41172 13.7693Z",
    fill: "#201714"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.91304,
    cy: 3.65217,
    rx: 7.91304,
    ry: 3.65217,
    transform: "matrix(-1 0 0 1 103.608 20.6953)",
    fill: "#E97A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.043 14.0219C106.043 21.766 98.6947 17.6522 85.934 17.6522C78.1899 17.6522 77.999 21.766 77.999 14.0219C77.999 6.27782 84.2768 0 92.0209 0C99.765 0 106.043 6.27782 106.043 14.0219Z",
    fill: "#201714"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2168,
    cy: 8.82617,
    r: 4.17383,
    fill: "#F7F7F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.8125,
    cy: 13,
    r: 2,
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.585 20.4605C106.153 20.6543 106.615 20.8118 106.952 20.8999C107.603 21.0697 108.268 20.6799 108.438 20.0294C108.608 19.3788 108.218 18.7138 107.567 18.5441C107.37 18.4927 107.046 18.3805 106.613 18.2309C104.627 17.5443 100.363 16.0698 95.6946 16.0698C92.8541 16.0698 88.4671 16.6041 84.7893 17.1692C82.9385 17.4535 81.2421 17.7497 79.9757 17.9983C79.3442 18.1222 78.809 18.2365 78.411 18.3333C78.214 18.3812 78.0346 18.4287 77.8878 18.4746C77.8156 18.4971 77.7338 18.5246 77.6542 18.5572L77.6508 18.5586C77.6016 18.5787 77.4303 18.6486 77.267 18.7835C76.7487 19.2118 76.6757 19.9792 77.104 20.4975C77.4774 20.9493 78.1085 21.0627 78.6076 20.8005C78.6096 20.7999 78.6116 20.7993 78.6138 20.7986C78.6886 20.7752 78.8107 20.7418 78.9865 20.6991C79.334 20.6146 79.8293 20.5083 80.4447 20.3875C81.6721 20.1465 83.3348 19.856 85.159 19.5757C88.8311 19.0115 93.0569 18.5046 95.6946 18.5046C99.854 18.5046 103.462 19.7358 105.585 20.4605Z",
    fill: "#201714"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.719 9C108.919 11.8 105.552 13.5 103.719 14C102.052 14.8333 99.919 16.4 104.719 16C109.519 15.6 108.719 11.1667 107.719 9Z",
    fill: "#201714"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.891 13.7693C109.043 16.6952 105.362 15.8742 103.627 15.0979C101.81 14.6851 99.1673 14.5433 103.132 17.2785C107.097 20.0137 109.29 16.0787 109.891 13.7693Z",
    fill: "#201714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes6);
export default __webpack_public_path__ + "static/media/eyes-6.635a95250ef98c0511445ecf933d6283.svg";
export { ForwardRef as ReactComponent };